/**
 * components/filters/FilterBar.js — Шүүлтийн мөрийн байршуулагч.
 *
 * Дотор нь шүүлтийн бусад компонент (SearchInput, SelectFilter, UnitFilter,
 * DateRangeFilter)-ийг байрлуулж, сонголтоор «Цэвэрлэх» товч харуулна.
 *
 * Props:
 *   children               — шүүлтийн элементүүд
 *   onClear                — «Цэвэрлэх» дархад
 *   values                 — ⭐ шүүлтийн УТГУУДЫН массив. Аль нэг нь дүүрэн
 *                            бол товч өөрөө гарч ирнэ.
 *   showClear              — гар аргаар дарж бичих (values-ээс давуу)
 *   clearLabel, clearColor — товчны текст / өнгө
 *   style                  — гадна wrapper style override
 *
 * ⚠ Яагаад `values` вэ: өмнө нь `showClear`-ыг дуудагч бүр ГАРААР угсардаг
 *   байсан бөгөөд шүүлт нэмэгдэхэд тэр илэрхийлэлд оруулахаа мартдаг байв.
 *   Үр дүнд нь тухайн шүүлтээр шүүсэн хэрэглэгчид «Цэвэрлэх» товч ОГТ
 *   харагдахгүй, буцаах арга байхгүй болдог (high_risk/reference дээр яг
 *   ийм алдаа гарсан). `values`-д бүх утгыг өгвөл энэ анги алдаа боломжгүй.
 */
import React from "react";
import { ConfigProvider } from "antd";

export default function FilterBar({
  children,
  onClear,
  values,
  showClear,
  clearLabel = "Цэвэрлэх",
  clearColor = "#1B7A45",
  style,
  /**
   * Мөрөн доторх БҮХ antd элементийн хэмжээ.
   *
   * ⚠ ЯАГААД ЭНД ТӨВЛӨРҮҮЛСЭН БЭ:
   *   Өмнө нь дуудагч тал зөвхөн зарим хүүхдэд (`SearchInput`,
   *   `SelectFilter`) `size="small"` өгдөг байсан бол `UnitFilter`
   *   (DepartmentTseh/Negj) ба `DateRangeFilter` (RangePicker) нь size
   *   ХҮЛЭЭН АВДАГГҮЙ тул antd-ийн анхдагч `middle` хэвээр үлдэж, нэг
   *   мөрөнд 24px ба 32px элементүүд ХОЛИЛДОЖ харагддаг байв.
   *
   *   Одоо ConfigProvider-оор бүгдэд НЭГ хэмжээ өгнө. Хүүхдүүдийн
   *   `size` анхдагч нь `undefined` тул эндээс ӨВЛӨНӨ (SearchInput.js,
   *   SelectFilter.js-ийн тайлбарт заасан зарчим).
   */
  size = "small",
}) {
  const auto = Array.isArray(values)
    ? values.some((v) => {
        if (Array.isArray(v)) return v.length > 0;
        if (v === null || v === undefined) return false;
        if (typeof v === "boolean") return v;
        return String(v) !== "";
      })
    : false;
  const visible = showClear === undefined ? auto : !!showClear;

  // Товчны өндөр нь antd-ийн хэмжээтэй тохирно — эс бөгөөс цэвэрлэх товч
  // ганцаараа өндөр үлдэнэ.
  const btnSize = size === "large" ? 40 : size === "small" ? 24 : 32;

  return (
    <ConfigProvider componentSize={size}>
    <div
      style={{
        display: "flex",
        gap: 8,
        flexWrap: "wrap",
        alignItems: "center",
        // Гадагш халихаас сэргийлнэ — доторх элементүүд өөрсдөө багасна
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {children}
      {visible && (
        // ICON товч — шүүлтийн мөр нь цех, хэсэг, огноо, хайлтаар дүүрэн
        // байдаг тул текст товч зай эзэлж, бусад сонгогчийг шахдаг байв.
        // Утга нь `title`-ээр (hover) хадгалагдана.
        <button
          onClick={onClear}
          title={clearLabel}
          aria-label={clearLabel}
          style={{
            flex: "0 0 auto",
            width: btnSize,
            height: btnSize,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: size === "small" ? 6 : 8,
            border: "1px solid #E6E9EF",
            background: "#fff",
            color: clearColor,
            fontSize: size === "small" ? 12 : 14,
            cursor: "pointer",
            lineHeight: 1,
          }}
        >
          {/* ⚠ Font Awesome FREE 5.11.2 — FA6-гийн нэр (fa-filter
              г.м) энэ bundle-д БАЙХГҮЙ тул FA5 нэрийг ашиглана. */}
          <i className="fas fa-eraser" />
        </button>
      )}
    </div>
    </ConfigProvider>
  );
}
